import { Injectable } from '@angular/core';
import { Router, UrlTree } from '@angular/router';
import { PulseSurveyBloc } from '@kp/pulse-survey/pulse-survey.bloc';
import { Observable, of } from 'rxjs';
import { catchError, first, map, switchMap } from 'rxjs/operators';
import { ReturnUrlService } from '../services/return-url.service';

@Injectable({
  providedIn: 'root',
})
export class PulseSurveyAvailableGuard {
  constructor(
    private _pulseSurveyBloc: PulseSurveyBloc,
    private _returnUrlService: ReturnUrlService,
    private _router: Router
  ) {}

  canActivate(/*route: ActivatedRouteSnapshot, state: RouterStateSnapshot*/): Observable<boolean | UrlTree> {
    // Short circuit this guard if user has a non-default returnUrl
    if (!this._returnUrlService.isDefaultUrl) {
      return of(true);
    }
    return this._pulseSurveyBloc.pulseSurveyCheckAllowed$.pipe(
      // only take the first once because setting allowPulseSurveyCheck to false
      // would fire this off again, and we only care about the initial state
      // until the next time through the guard via a route
      first(),
      switchMap((isAllowed) => {
        if (isAllowed) {
          this._pulseSurveyBloc.getPulseSurvey();
          this._pulseSurveyBloc.allowPulseSurveyCheckToday(false);
          return this._pulseSurveyBloc.hasPulseSurvey$;
        }
        // may not have values if getPulseSurvey wasn't fired if
        // pulse survey check was not allowed
        return of(false);
      }),
      map((hasPulseSurvey) => {
        if (hasPulseSurvey) {
          return this._router.parseUrl('/pulse_survey');
        }
        return true;
      }),
      catchError((error) => {
        console.warn('There was an error trying to check for Pulse Survey', error);
        // still allow to the page if there is an error determining if there is a Pulse Survey
        return of(true);
      })
    );
  }
}
